const STATUT_PROJET = {
	EN_COURS: 0,
	BROUILLON: 1,
	SOLDE: 2,
	TOUTES: 3,
} as const;

export default STATUT_PROJET;
